<template>
  <div class="wizard-selector">
    <div class="layout layout--primary">
      <div class="layout__container">
        <div class="grid grid--primary">
          <div class="wizard-selector__col">
            <n-link
              :to="localePath({ name: 'wizard' })"
              class="wizard-selector__btn btn btn--primary btn--medium"
            >
              {{ $t('wizard_selector.custom_button_label') }}
            </n-link>
            <responsive-img
              :resolutions="[1]"
              :width="600"
              alt=""
              class="wizard-selector__img"
              src="/images/intro/00_Intro_Individuell_Desktop_972_550.png"
            />
            <div class="wizard-selector__description">
              <p>
                {{ $t('wizard_selector.custom_button_description') }}
              </p>
            </div>
          </div>
          <div class="wizard-selector__col">
            <n-link
              :to="localePath({ name: 'viewpoint-persona' })"
              class="wizard-selector__btn btn btn--primary btn--medium"
            >
              {{ $t('wizard_selector.persona_button_label') }}
            </n-link>
            <responsive-img
              :resolutions="[1]"
              :width="600"
              alt=""
              class="wizard-selector__img"
              src="/images/intro/00_Intro_Personas_Desktop_972_550.png"
            />
            <div class="wizard-selector__description">
              <p>
                {{ $t('wizard_selector.persona_button_description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ResponsiveImg from '@/components/responsive-img/responsive-img'

  export default {
    components: { ResponsiveImg },
    props: {},
  }
</script>

<style lang="scss" src="./_wizard-selector.scss" />
